module.exports = __webpack_public_path__ + "static/media/ic-video-camera.b02ce6a5.png";